import { Directive, ElementRef, Renderer2, OnInit, Input } from '@angular/core';

@Directive({
    selector: '[skeletonLoaderPipe]'
})
export class SkeletonLoaderPipe implements OnInit {
    @Input() skeletonLoaderPipe: 'rect' | 'square' | 'circle' = 'square';

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    public ngOnInit(): void {
        this.renderer.addClass(this.el.nativeElement, 'ui-skeleton-loader');
        this.renderer.addClass(this.el.nativeElement, `ui-skeleton-loader-${this.skeletonLoaderPipe}`);
    }
}
